module.exports = __webpack_public_path__ + "static/media/LinotteSemiBold.edea38a2.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Linotte/LinotteSemiBold.otf
// module id = 239
// module chunks = 0